import WebRequest from './client/WebRequest.js';
import { MutationKeys } from './service.js';
import { QUERY_STALE_TIME } from './constants.js';
import { queryString } from './query-string.js';
import { sanitizeAttributionHeaderValue } from './treatment-attribution.js';
export var GetTreatmentPhotos;
(function (GetTreatmentPhotos) {
    function queryKey(storyId) {
        return ['treatment-photos', storyId];
    }
    GetTreatmentPhotos.queryKey = queryKey;
    function api(client, storyId) {
        return client.execute(WebRequest.GET(`/treatments/patient-api/stories/${encodeURIComponent(storyId)}/photos`));
    }
    GetTreatmentPhotos.api = api;
    function query(client, storyId) {
        return {
            queryKey: queryKey(storyId),
            queryFn: () => api(client, storyId),
            staleTime: 0,
        };
    }
    GetTreatmentPhotos.query = query;
})(GetTreatmentPhotos || (GetTreatmentPhotos = {}));
export var UpdateTreatmentPhotos;
(function (UpdateTreatmentPhotos) {
    function mutation(client, storyId) {
        return {
            mutationKey: ['update-treatment-photos', storyId],
            mutationFn: (body) => client.execute(WebRequest.POST(`/treatments/patient-api/stories/${encodeURIComponent(storyId)}/photos`).body(body)),
        };
    }
    UpdateTreatmentPhotos.mutation = mutation;
})(UpdateTreatmentPhotos || (UpdateTreatmentPhotos = {}));
export var CompleteTreatmentPhotos;
(function (CompleteTreatmentPhotos) {
    function mutation(client, storyId) {
        return {
            mutationKey: ['complete-treatment-photos', storyId],
            mutationFn: () => client.execute(WebRequest.POST(`/treatments/patient-api/stories/${encodeURIComponent(storyId)}/photos/complete`)),
        };
    }
    CompleteTreatmentPhotos.mutation = mutation;
})(CompleteTreatmentPhotos || (CompleteTreatmentPhotos = {}));
// Medicare/IHI skipped in the quiz and added after payment.
export var GetTreatmentHealthIdentifier;
(function (GetTreatmentHealthIdentifier) {
    function queryKey(storyId) {
        return ['treatment-health-identifier', storyId];
    }
    GetTreatmentHealthIdentifier.queryKey = queryKey;
    function api(client, storyId) {
        return client.execute(WebRequest.GET(`/treatments/patient-api/stories/${encodeURIComponent(storyId)}/health-identifier`));
    }
    GetTreatmentHealthIdentifier.api = api;
    function query(client, storyId) {
        return {
            queryKey: queryKey(storyId),
            queryFn: () => api(client, storyId),
            staleTime: 0,
        };
    }
    GetTreatmentHealthIdentifier.query = query;
})(GetTreatmentHealthIdentifier || (GetTreatmentHealthIdentifier = {}));
export var SubmitTreatmentHealthIdentifier;
(function (SubmitTreatmentHealthIdentifier) {
    function mutation(client, storyId) {
        return {
            mutationKey: ['submit-treatment-health-identifier', storyId],
            mutationFn: (body) => client.execute(WebRequest.POST(`/treatments/patient-api/stories/${encodeURIComponent(storyId)}/health-identifier`).body(body)),
        };
    }
    SubmitTreatmentHealthIdentifier.mutation = mutation;
})(SubmitTreatmentHealthIdentifier || (SubmitTreatmentHealthIdentifier = {}));
const TREATMENT_QUIZ_ATTRIBUTION_HEADERS = {
    utmSource: 'X-Treatment-Attribution-Utm-Source',
    utmMedium: 'X-Treatment-Attribution-Utm-Medium',
    utmCampaign: 'X-Treatment-Attribution-Utm-Campaign',
    utmContent: 'X-Treatment-Attribution-Utm-Content',
    utmTerm: 'X-Treatment-Attribution-Utm-Term',
    gclid: 'X-Treatment-Attribution-Gclid',
    gbraid: 'X-Treatment-Attribution-Gbraid',
    wbraid: 'X-Treatment-Attribution-Wbraid',
    fbclid: 'X-Treatment-Attribution-Fbclid',
    fbc: 'X-Treatment-Attribution-Fbc',
    fbp: 'X-Treatment-Attribution-Fbp',
};
export function convertTreatmentType(type) {
    switch (type) {
        case 'ErectileDysfunction':
            return 'ed';
        case 'PrematureEjaculation':
            return 'pe';
        case 'MaleHairLoss':
            return 'mhl';
        case 'WeightLoss':
            return 'wl';
        default:
            throw new Error(`Unsupported treatment type: ${type}`);
    }
}
export var GetTreatmentPlanStatuses;
(function (GetTreatmentPlanStatuses) {
    async function api(client) {
        const request = WebRequest.GET('/treatments/patient-api/statuses');
        return client.execute(request);
    }
    GetTreatmentPlanStatuses.api = api;
    function queryKey() {
        return ['treatment-plan-statuses'];
    }
    GetTreatmentPlanStatuses.queryKey = queryKey;
    function query(client) {
        return {
            queryFn: async () => await api(client),
            queryKey: queryKey(),
            staleTime: QUERY_STALE_TIME,
        };
    }
    GetTreatmentPlanStatuses.query = query;
})(GetTreatmentPlanStatuses || (GetTreatmentPlanStatuses = {}));
export var GetPersonalisedTreatmentPlan;
(function (GetPersonalisedTreatmentPlan) {
    async function api(client, type) {
        const request = WebRequest.GET(`/treatments/patient-api/${type}/personalised-plan`);
        return client.execute(request);
    }
    GetPersonalisedTreatmentPlan.api = api;
    function queryKey(type) {
        return ['personalised-treatment-plan', type];
    }
    GetPersonalisedTreatmentPlan.queryKey = queryKey;
    function query(client, type) {
        return {
            queryFn: async () => await api(client, type),
            queryKey: queryKey(type),
            staleTime: QUERY_STALE_TIME,
        };
    }
    GetPersonalisedTreatmentPlan.query = query;
})(GetPersonalisedTreatmentPlan || (GetPersonalisedTreatmentPlan = {}));
export var FetchLatestQuizState;
(function (FetchLatestQuizState) {
    async function api(type, client) {
        const request = WebRequest.GET(`/treatments/${type}/quiz/latest`);
        return client.execute(request);
    }
    FetchLatestQuizState.api = api;
})(FetchLatestQuizState || (FetchLatestQuizState = {}));
export var FetchQuizMetadata;
(function (FetchQuizMetadata) {
    async function api(type, client) {
        const request = WebRequest.GET(`/treatments/${type}/quiz/metadata`);
        return client.execute(request);
    }
    FetchQuizMetadata.api = api;
})(FetchQuizMetadata || (FetchQuizMetadata = {}));
export var UpdateQuizState;
(function (UpdateQuizState) {
    async function api(client, type, state, includePii = false, attribution) {
        const request = WebRequest.POST(`/treatments/${type}/quiz?includePii=${includePii}`).body(state);
        appendAttributionHeaders(request, attribution);
        return client.execute(request);
    }
    UpdateQuizState.api = api;
    function mutation(client, type) {
        return {
            mutationFn: async ({ state, includePii = false, attribution, }) => await api(client, type, state, includePii, attribution),
            mutationKey: MutationKeys.UpdateQuizState(type),
        };
    }
    UpdateQuizState.mutation = mutation;
})(UpdateQuizState || (UpdateQuizState = {}));
function appendAttributionHeaders(request, attribution) {
    if (!attribution)
        return;
    for (const [field, header] of Object.entries(TREATMENT_QUIZ_ATTRIBUTION_HEADERS)) {
        const maxLength = field === 'utmSource' || field === 'utmMedium'
            ? 128
            : field === 'fbc'
                ? 512
                : 256;
        const sanitized = sanitizeAttributionHeaderValue(attribution[field], maxLength);
        if (sanitized)
            request.header(header, encodeURIComponent(sanitized));
    }
}
// Web checkout. Uses the v2 checkout endpoint: weight loss pays the $40 initial assessment at
// checkout and the first month when the plan is accepted.
export var CreatePaymentLink;
(function (CreatePaymentLink) {
    async function api(client, type, params = {}) {
        const search = queryString(params, { skipNulls: true });
        const request = WebRequest.POST(search
            ? `/treatments/${type}/quiz/v2/payment?${search}`
            : `/treatments/${type}/quiz/v2/payment`);
        return client.execute(request);
    }
    CreatePaymentLink.api = api;
    function mutation(client, type) {
        return {
            mutationFn: async (params = {}) => await api(client, type, params),
            mutationKey: MutationKeys.CreateTreatmentPaymentLink(type),
        };
    }
    CreatePaymentLink.mutation = mutation;
})(CreatePaymentLink || (CreatePaymentLink = {}));
// Mobile checkout, v1: the pricing released mobile builds show in their quiz (weight loss:
// $89.90 initial consultation that includes the first month, nothing charged on acceptance).
// The mobile app keeps using this until its quiz and acceptance copy are updated for the
// assessment model; then switch it to CreateTreatmentMobilePaymentV2.
export var CreateTreatmentMobilePayment;
(function (CreateTreatmentMobilePayment) {
    async function api(client, type, params = {}) {
        const search = queryString(params, { skipNulls: true });
        const request = WebRequest.POST(search
            ? `/treatments/${type}/quiz/mobile-payment?${search}`
            : `/treatments/${type}/quiz/mobile-payment`);
        return client.execute(request);
    }
    CreateTreatmentMobilePayment.api = api;
    function mutation(client, type) {
        return {
            mutationFn: async (params = {}) => await api(client, type, params),
            mutationKey: MutationKeys.CreateTreatmentMobilePayment(type),
        };
    }
    CreateTreatmentMobilePayment.mutation = mutation;
})(CreateTreatmentMobilePayment || (CreateTreatmentMobilePayment = {}));
// Mobile checkout, v2: weight loss pays the $40 initial assessment at checkout and the first
// month when the plan is accepted. Only for builds whose quiz and acceptance screens say so.
export var CreateTreatmentMobilePaymentV2;
(function (CreateTreatmentMobilePaymentV2) {
    async function api(client, type, params = {}) {
        const search = queryString(params, { skipNulls: true });
        const request = WebRequest.POST(search
            ? `/treatments/${type}/quiz/v2/mobile-payment?${search}`
            : `/treatments/${type}/quiz/v2/mobile-payment`);
        return client.execute(request);
    }
    CreateTreatmentMobilePaymentV2.api = api;
    function mutation(client, type) {
        return {
            mutationFn: async (params = {}) => await api(client, type, params),
            mutationKey: MutationKeys.CreateTreatmentMobilePayment(type),
        };
    }
    CreateTreatmentMobilePaymentV2.mutation = mutation;
})(CreateTreatmentMobilePaymentV2 || (CreateTreatmentMobilePaymentV2 = {}));
export var UpdateEvaluationResult;
(function (UpdateEvaluationResult) {
    async function api(client, reviewId, result) {
        const request = WebRequest.POST(`/treatments/story-reviews/${reviewId}/evaluation-result`).body(result);
        return client.executeEmpty(request);
    }
    function mutation(client, reviewId) {
        return {
            mutationFn: (result) => api(client, reviewId, result),
            mutationKey: ['update-evaluation-result', reviewId],
        };
    }
    UpdateEvaluationResult.mutation = mutation;
})(UpdateEvaluationResult || (UpdateEvaluationResult = {}));
export var AcceptTreatmentPlan;
(function (AcceptTreatmentPlan) {
    async function api(client, storyId, annual, selfDispense) {
        const request = WebRequest.POST(`/treatments/patient-api/stories/${storyId}/accept-treatment?annual=${annual}&selfDispense=${selfDispense}`);
        return client.executeEmpty(request);
    }
    function mutation(client) {
        return {
            mutationFn: ({ storyId, annual, selfDispense, }) => api(client, storyId, annual, selfDispense),
            mutationKey: ['accept-treatment-plan'],
        };
    }
    AcceptTreatmentPlan.mutation = mutation;
})(AcceptTreatmentPlan || (AcceptTreatmentPlan = {}));
export var UpdateFeedbackForUpcomingOrder;
(function (UpdateFeedbackForUpcomingOrder) {
    async function api(client, storyId, orderId, comment) {
        const body = { comment };
        const request = WebRequest.POST(`/treatments/patient-api/stories/${storyId}/upcoming-orders/${orderId}/comment`).body(body);
        return client.executeEmpty(request);
    }
    function mutation(client, storyId, orderId) {
        return {
            mutationFn: ({ comment }) => api(client, storyId, orderId, comment),
            mutationKey: ['update-feedback-for-upcoming-order', storyId, orderId],
        };
    }
    UpdateFeedbackForUpcomingOrder.mutation = mutation;
})(UpdateFeedbackForUpcomingOrder || (UpdateFeedbackForUpcomingOrder = {}));
export var UpdateProcessingDateForUpcomingOrder;
(function (UpdateProcessingDateForUpcomingOrder) {
    async function api(client, storyId, orderId, requestBody) {
        const request = WebRequest.POST(`/treatments/patient-api/stories/${storyId}/upcoming-orders/${orderId}/processing-date`).body(requestBody);
        return client.executeEmpty(request);
    }
    function mutation(client, storyId, orderId) {
        return {
            mutationFn: (request) => api(client, storyId, orderId, request),
            mutationKey: [
                'update-processing-date-for-upcoming-order',
                storyId,
                orderId,
            ],
        };
    }
    UpdateProcessingDateForUpcomingOrder.mutation = mutation;
})(UpdateProcessingDateForUpcomingOrder || (UpdateProcessingDateForUpcomingOrder = {}));
export var GetTreatmentHistory;
(function (GetTreatmentHistory) {
    async function api(client, reference, after) {
        let url = `/doctor/consultations/${reference}/treatment-history`;
        if (after !== null) {
            url = `${url}?after=${after}`;
        }
        const request = WebRequest.GET(url);
        return client.execute(request);
    }
    function query(client, reference) {
        return {
            queryFn: async ({ pageParam: { after }, }) => await api(client, reference, after),
            queryKey: ['get-treatment-history', reference],
            staleTime: QUERY_STALE_TIME,
        };
    }
    GetTreatmentHistory.query = query;
})(GetTreatmentHistory || (GetTreatmentHistory = {}));
